import app from 'src/app';

app.models.intl.registerLoader({
	key: 'route.leaderboard.schedule',
	messages: {
		en: () => import('./en'),
		ru: () => import('./ru'),
	},
});
